module.exports = __webpack_public_path__ + "img/OhOhYes.89d26ea0.svg";